import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P } from "../AbstractElements";

import { useNavigate } from "react-router-dom";
import man from "../assets/images/dashboard/profile.png";

import { useTranslation } from 'react-i18next';

import CustomizerContext from "../_helper/Customizer";
import { ToastContainer, toast } from "react-toastify";
import AuthService from "../api/AuthService";

const Signin = ({ selected }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const { t } = useTranslation();

  const [value, setValue] = useState(localStorage.getItem("profileURL" || man));
  const [name, setName] = useState(localStorage.getItem("Name"));

  useEffect(() => {
    localStorage.setItem("profileURL", man);
    localStorage.setItem("Name", "Emay Walter");
  }, [value, name]);

  const loginAuth = async (e) => {
    e.preventDefault();
    setValue(man);
    setName("Emay Walter");

    const data = {
      phone_number: email,
      password: password
    }

    AuthService.login(data)
        .then(response => {

          const responseData = response.data
          console.log("ROLE ::: ", responseData)
          if(responseData.response.status_code === 200){

            if(responseData.data.role === "admin"){

              toast.success("Successfully logged in!..");
              localStorage.setItem("token", responseData.data.access_token)
              localStorage.setItem("userId", responseData.data.userId)
              localStorage.setItem("profile", responseData.data.profile)
              localStorage.setItem("login", JSON.stringify(true))
              history(`${process.env.PUBLIC_URL}/app/task/${layoutURL}`)

            }else{
              toast.error("Vous n'avez accès!")
            }

          }

          if(responseData.response.status_code === 422){
            toast.error("Email ou mot de passe incorrecte");
            /*setEmailHasErrorMessage(true)
            setPasswordHasErrorMessage(true)
            setEmailErrorMessage(responseData.error.details.email)
            setPasswordErrorMessage(responseData.error.details.password)*/
          }

        })
        .catch(error => {
          console.error("error ::: ",error.status)
          console.error("error ::: ",error.code)
          console.error("error ::: ",error.message)
        })

    /*if (email === "test@gmail.com" && password === "test123") {
      localStorage.setItem("login", JSON.stringify(true));
      history(`${process.env.PUBLIC_URL}/dashboard/default/${layoutURL}`);
      toast.success("Successfully logged in!..");
    } else {
      toast.error("You enter wrong password or username!..");
    }*/

  };

  return (
    <Fragment>
      <Container fluid={true} className="p-0 login-page">
        <Row>
          <Col xs="12">
            <div className="login-card">
              <div className="login-main login-tab">
                <Form className="theme-form">
                  {/*<Language />*/}
                  <H4>Connectez-vous</H4>
                  {/*<H4>{t('signinText')}</H4>
                  <H4>{selected === "simpleLogin" ? "" : "Sign In With Simple Login"}</H4>*/}
                  <P>Entrez votre numéro et mot de passe</P>
                  {/*<P>{t('enterLogin')}</P>*/}
                  <FormGroup>
                    <Label className="col-form-label">Numéro de téléphone</Label>
                    <Input className="form-control" placeholder={"9xxxxxxx"} type="email" onChange={(e) => setEmail(e.target.value)} value={email} />
                  </FormGroup>
                  <FormGroup className="position-relative">
                    <Label className="col-form-label">Mot de passe</Label>
                    <div className="position-relative">
                      <Input className="form-control" placeholder={"test123"} type={togglePassword ? "text" : "password"} onChange={(e) => setPassword(e.target.value)} value={password} />
                      <div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}>
                        <span className={togglePassword ? "" : "voir"}></span>
                      </div>
                    </div>
                  </FormGroup>
                  <div className="position-relative form-group mb-0">
                    {/*<div className="checkbox">
                      <Input id="checkbox1" type="checkbox" />
                      <Label className="text-muted" for="checkbox1">
                        {RememberPassword}
                      </Label>
                    </div>
                    <a className="link" href="#javascript">
                      {ForgotPassword}
                    </a>*/}
                    <Btn attrBtn={{ color: "primary", className: "d-block w-100 mt-2", onClick: (e) => loginAuth(e) }}>Se Connecter</Btn>
                  </div>
                  {/*
                    <OtherWay />
                  */}
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </Fragment>
  );
};

export default Signin;
